<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between mb-3">
          <div>
            <span class="theme-color-one">ส่วนที่ 4 :</span> เอกสารแนบ
          </div>
          <Button
              theme="6"
              @onClick="addAttachment"
          >
            + เพิ่มไฟล์
          </Button>
        </div>

        <!-- Form 1 -->
        <div>
          <div class="theme-color-seven mb-3">
            *ไฟล์ที่ระบบรองรับ .PDF/.doc (สูงสุด 50 MB/ไฟล์)
          </div>
          
          <v-layout class="mt-3" v-for="(file, f) in attachment" :key="f">
            <template v-if="!file.doc_type || file.doc_type === null">
              <v-flex xs7>
              <v-file-input
                  v-model="files[f]"
                  :id="'file' + f"
                  :rules="rulesFile"
                  color="#F15A29"
                  :clearable="false"
                  style="border-radius: 30px"
                  outlined
                  height="36"
                  placeholder=""
                  prepend-icon=""
                  accept="application/pdf,.doc,.docx"
                  v-show="
                      checkValType(file.file_name) == 'object' ||
                      file.file_name == '' ||
                      file.file_name == null
                    "
                  @change="addToAttachment(files[f],f)"
              ></v-file-input>
              <v-text-field
                  v-show="checkValType(file.file_name) == 'string'"
                  v-model="file.file_name"
                  outlined
                  height="36"
                  color="#F15A29"
                  style="border-radius: 30px"
                  readonly
              ></v-text-field>
            </v-flex>
              <v-flex shrink ml-3>
                <v-btn
                    depressed
                    dark
                    rounded
                    width="100"
                    color="#464647"
                    @click="selectFile(f)"
                >
                  <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
                  <span class="font-12 font-w-700">อัพโหลด</span>
                </v-btn>
              </v-flex>
              <v-flex shrink ml-3>
                <v-btn
                    depressed
                    height="35"
                    width="35"
                    fab
                    dark
                    color="#FD0C0C"
                    @click="removeFile(f)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-flex>
            </template>

          </v-layout>

        </div>

      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "@/components/input/TextField"
import SwitchInset from "@/components/input/SwitchInset"
import AutoBox from "@/components/input/AutoBox"
import Button from "@/components/input/Button"
import { eventBus } from "@/plugins/global-funcs"
import { mapState } from "vuex"
import axios from "axios";

export default {
  name: "FourthForm",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    },
    formData: Array,
  },
  data () {
    return {
      form: [],
      files: [],
      attachment: [{}],
      rulesFile: [
        (value) => !!value || "กรุณาแนบเอกสาร",
        (value) => (!value || value.size <= 50000000) || "ขนาดไฟล์ต้องน้อยกว่า 50 MB!",
      ],
    }
  },
  watch: {
    formData: {
      handler(newValue) {
        this.form = JSON.parse(JSON.stringify(newValue));
      },
      deep: true,
      immediate: true,
    },
    files: {
      handler (val) {
        this.form = this.attachment
        console.log('this.form@watch', this.form)
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      AttachmentForm: state => state.CForm.AttachmentForm
    })
  },
  created () {
    if (this.isSameId) this.form = this.AttachmentForm
    eventBus.$on('fourthForm', () => {
      eventBus.$emit('fourthFormSend', this.form)
    })

    if(this.formData){
      this.setData()
    }

    eventBus.$on('fourthFormSetData', () => this.setData())
  },
  methods: {
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    setData(){
      this.form = this.formData
      this.attachment = []
      this.formData.forEach((item) => {
        this.attachment.push(item)
      })
    },
    addAttachment () {
      this.attachment.push({})
      this.form = this.attachment
      console.log('addAttachment', this.form)
    },
    addToAttachment(file, i){
      console.log('file size', file.size)
      //check if file size > 10mb then show dialog modal
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      // Check file type
      if (!allowedTypes.includes(file.type)) {
        this.$store.commit("General/setModal", {
          title: "ประเภทไฟล์ไม่ถูกต้อง",
          theme: "warning",
          text: "กรุณาแนบประเภทไฟล์ให้ถูกต้อง",
          showCancel: false,
          buttonText: "ตกลง",
        });
        // Remove the last file
        this.attachment.pop();
        this.files.pop();
        return;
      }
      
      if(file.size > 50000000){
        this.$store.commit('General/setModal', {
          title: 'ขนาดไฟล์เกิน 50 MB',
          theme: 'warning',
          text: 'กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB',
          showCancel: false,
          buttonText: 'ตกลง'
        })
        //remove file in to last index of attachment
        this.attachment.pop()
        this.files.pop()
        return
      }
      this.attachment[i] = file;
      console.log('addToAttachment', this.attachment)
    },
    removeFile(id) {
      this.attachment.splice(id, 1);
      this.files.splice(id, 1);
      this.form = this.attachment
      console.log('removeFile', this.form)
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    checkValType(val) {
      return typeof val;
    },
  }
}
</script>

<style scoped>

</style>